import React from 'react';
import { Box } from '@mui/material';

export function GenerateReportForm() {
  return (
    <Box />
  );
}
